import { Check, MessageCircle } from "lucide-react";
import { RichText } from "./RichText";
import { QuoteButton, WhatsAppButton } from "../home/CtaButtons";

const AsideCta = ({ onderwerp }) => (
  <div className="card p-6 lg:sticky lg:top-36" style={{ boxShadow: "var(--shadow-2)" }} data-testid="article-aside-cta">
    <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-gold">Vrijblijvend</p>
    <p className="mt-2 font-display text-[19px] font-bold leading-snug text-ink">Benieuwd wat dit voor uw woning kost?</p>
    <p className="mt-2 text-[14.5px] leading-relaxed text-slate-600">Beantwoord vijf korte vragen en ontvang een persoonlijke prijsindicatie. Foto's meesturen kan.</p>
    <div className="mt-5 flex flex-col gap-3">
      <QuoteButton location="product-aside" onderwerp={onderwerp} label="Ontvang een prijsindicatie" className="w-full" />
      <WhatsAppButton location="product-aside" className="w-full" />
    </div>
    <p className="mt-4 flex items-center gap-1.5 text-[13px] text-slate-500"><MessageCircle className="h-3.5 w-3.5" aria-hidden="true" /> Liever eerst een vraag stellen? Dat kan ook.</p>
  </div>
);

export const ProductArticle = ({ title, sections, onderwerp }) => (
  <section id="informatie" aria-labelledby="informatie-title" className="section scroll-mt-12" data-testid="product-article">
    <div className="container-tight grid gap-12 lg:grid-cols-12">
      <article className="lg:col-span-8">
        <p className="eyebrow">Goed om te weten</p>
        <h2 id="informatie-title" className="h2 mt-3 text-balance">{title}</h2>
        {sections.map((s) => (
          <div key={s.title} className="mt-10 border-t border-slate-200 pt-8 first-of-type:border-0">
            <h3 className="text-[20px] font-bold leading-snug text-ink sm:text-[22px]">{s.title}</h3>
            {s.text.map((t) => <p key={t.slice(0, 24)} className="mt-3 max-w-[68ch] leading-relaxed text-slate-700"><RichText text={t} /></p>)}
            {s.list && (
              <ul className="mt-4 grid gap-2 sm:grid-cols-2">
                {s.list.map((li) => <li key={li} className="flex items-start gap-2 text-[15px] text-slate-700"><Check className="mt-1 h-4 w-4 shrink-0 text-maas" aria-hidden="true" />{li}</li>)}
              </ul>
            )}
            {s.after && <p className="mt-4 max-w-[68ch] leading-relaxed text-slate-700"><RichText text={s.after} /></p>}
          </div>
        ))}
      </article>
      <aside className="lg:col-span-4"><AsideCta onderwerp={onderwerp} /></aside>
    </div>
  </section>
);
